<div class="modal-header">
  <span class="modal-title">{{ title }}</span>
</div>
<div class="modal-body">
  <div class="row" *ngIf="divType === 'text'">
    <div class="col-12">
      {{ subText }}
    </div>
  </div>
  <div class="row" *ngIf="divType === 'checkbox'">
    <div class="col-12">
      <p>{{ subText }}</p>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="confirmationCheck" [(ngModel)]="checked" />
        <label class="form-check-label" for="confirmationCheck">{{ checkboxLabel }}</label>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="divType === 'input'">
    <div class="col-12">
      <p>{{ "modules.expert-tool.FSF-download-modal-maximum-characters" | transloco }}: 150</p>
      <textarea [(ngModel)]="comment" class="comment-textarea" maxlength="150"></textarea>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="button-area float-end">
          <div class="displayed">
            <button type="button" class="btn btn-secondary" (click)="cancel()">
              {{ buttonSecondaryText }}
            </button>
            <button type="button" class="btn btn-primary" (click)="proceed()">
              {{ buttonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
